import { createFileRoute } from "@tanstack/react-router";
import { ServicePageTemplate } from "@/components/ServicePageTemplate";
import { serviceBySlug } from "@/data/services";
import { breadcrumbSchema, faqSchema, jsonLd, serviceSchema, absUrl } from "@/lib/seo";

const service = serviceBySlug["barnklippning"];

export const Route = createFileRoute("/barnklippning-stockholm")({
  head: () => ({
    meta: [
      { title: service.seoTitle },
      { name: "description", content: service.metaDescription },
      { property: "og:title", content: service.seoTitle },
      { property: "og:url", content: absUrl(service.url) },
    ],
    links: [{ rel: "canonical", href: absUrl(service.url) }],
    scripts: [jsonLd(serviceSchema(service)), jsonLd(faqSchema(service.faq)), jsonLd(breadcrumbSchema([{ name: "Hem", url: "/" }, { name: service.name, url: service.url }]))],
  }),
  component: () => <ServicePageTemplate service={service} />,
});
